import "./SplitterStyle.scss";
var SplitterComponent = /** @class */ (function () {
    function SplitterComponent(options) {
        // tslint:disable-next-line: variable-name
        this._is_splitter = true;
        this.options = options !== null && options !== void 0 ? options : {};
        if (this.options.minSizesInPX == null) {
            this.options.minSizesInPX = [];
        }
        if (this.options.minSizesInPX[0] == null) {
            this.options.minSizesInPX[0] = 0;
        }
        if (this.options.minSizesInPX[1] == null) {
            this.options.minSizesInPX[1] = 0;
        }
        if (this.options.maxSizesInPX == null) {
            this.options.maxSizesInPX = [];
        }
        if (!SplitterComponent.listenerRegistered) {
            SplitterComponent.listenerRegistered = true;
            this.registerListener();
        }
    }
    SplitterComponent.prototype.isEqual = function (node) {
        return this.__proto__ === node.__proto__;
    };
    SplitterComponent.prototype.render = function () {
        return { tag: "div", attr: { class: "split-comp" } };
    };
    SplitterComponent.prototype.registerListener = function () {
        var dragStartX = 0;
        var draggedEl;
        var elLeft;
        var elRight;
        var elLeftWidth;
        var elRightWidth;
        var isDown;
        function mousemove(e) {
            var _a;
            if (!isDown) {
                return;
            }
            e.preventDefault();
            // e.stopPropagation();
            // e.stopImmediatePropagation();
            var x;
            var orientation = draggedEl.parentElement.classList.contains("vstackpanel") ? "vertical" : "horizontal";
            var component = draggedEl._component;
            if (orientation === "horizontal") {
                x = e.pageX != null ? e.pageX : e.touches[0].pageX;
            }
            else {
                x = e.pageY != null ? e.pageY : e.touches[0].pageY;
            }
            var delta = dragStartX - x;
            if ((elLeftWidth - delta) < component.options.minSizesInPX[0] ||
                (elRightWidth + delta) < component.options.minSizesInPX[1]) {
                return;
            }
            if ((elLeftWidth - delta) > component.options.maxSizesInPX[0] ||
                (elRightWidth + delta) > component.options.maxSizesInPX[1]) {
                return;
            }
            if (orientation === "horizontal") {
                elLeft.style.width = (elLeftWidth - delta) + "px";
                elRight.style.width = (elRightWidth + delta) + "px";
            }
            else {
                elLeft.style.height = (elLeftWidth - delta) + "px";
                elRight.style.height = (elRightWidth + delta) + "px";
            }
            (_a = component.options.onResize) === null || _a === void 0 ? void 0 : _a.notify();
        }
        function mouseup(e) {
            var _a;
            isDown = false;
            // document.removeEventListener("mousemove", mousemove);
            // document.removeEventListener("touchmove", mousemove);
            document.removeEventListener("mouseup", mousedown);
            document.removeEventListener("touchend", mousedown);
            var component = draggedEl._component;
            var area1 = draggedEl.previousElementSibling;
            var args = {};
            if (area1 != null) {
                args.size1InPX = area1.getBoundingClientRect().width;
            }
            (_a = component.options.onResizeDone) === null || _a === void 0 ? void 0 : _a.notify(args);
        }
        function mousedown(e) {
            if (e.target.classList.contains("split-comp")) {
                isDown = true;
                var orientation_1 = e.target.parentElement.classList.contains("vstackpanel") ? "vertical" : "horizontal";
                if (orientation_1 === "horizontal") {
                    dragStartX = e.pageX != null ? e.pageX : e.touches[0].pageX;
                }
                else {
                    dragStartX = e.pageY != null ? e.pageY : e.touches[0].pageY;
                }
                draggedEl = e.target;
                elLeft = draggedEl.previousElementSibling;
                elRight = draggedEl.nextElementSibling;
                if (elLeft != null && elRight != null) {
                    if (orientation_1 === "horizontal") {
                        elLeftWidth = elLeft.getBoundingClientRect().width;
                        elRightWidth = elRight.getBoundingClientRect().width;
                    }
                    else {
                        elLeftWidth = elLeft.getBoundingClientRect().height;
                        elRightWidth = elRight.getBoundingClientRect().height;
                    }
                    document.body.addEventListener("mousemove", mousemove, { passive: false });
                    document.body.addEventListener("touchmove", mousemove, { passive: false });
                    document.body.addEventListener("mouseup", mouseup, false);
                    document.body.addEventListener("touchend", mouseup, false);
                }
            }
        }
        document.addEventListener("mousedown", mousedown);
        document.addEventListener("touchstart", mousedown);
        document.removeEventListener("mousemove", mousemove);
        document.removeEventListener("touchmove", mousemove);
    };
    SplitterComponent.listenerRegistered = false;
    return SplitterComponent;
}());
export { SplitterComponent };
